import React from "react";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
  FaPinterestP,
} from "react-icons/fa";

const SocialShare = [
  { Social: <FaFacebookF />, link: "https://www.facebook.com/dan.rutledge.5099" },
  { Social: <FaTwitter />, link: "https://www.twitter.com/danrutledge1" },
  { Social: <FaInstagram />, link: "https://www.instagram.com/danrutledge/" },
  { Social: <FaLinkedinIn />, link: "https://www.linkedin.com/in/dan-rutledge/" },
];

const Social = () => {
  return (
    <div className="nav social-icons justify-content-center text-sm-center justify-content-md-end">
      {SocialShare.map((val, i) => (
        <a key={i} href={`${val.link}`} rel="noreferrer" target="_blank">
          {val.Social}
        </a>
      ))}
    </div>
  );
};

export default Social;
